import React, { useState } from 'react';

const ActivationRequest = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  const requests = [
    { id: 1, date: '07-Apr-2025', name: 'Ayushi', mobile: '9528559514', email: 'ayushinegi078@gmail.com', price: '299', receipt: 'receipt1.jpg', status: 'Verified' },
    { id: 2, date: '07-Apr-2025', name: 'Umesh Goyal', mobile: '8728978118', email: 'ugoyal593@gmail.com', price: '299', receipt: 'receipt2.jpg', status: 'Verified' },
    { id: 3, date: '07-Apr-2025', name: 'Amit Singh', mobile: '7889375452', email: 'amitsinghmanhas2121@gmail.com', price: '299', receipt: 'receipt3.jpg', status: 'Verified' },
    { id: 4, date: '07-Apr-2025', name: 'Amit Singh', mobile: '0788937545', email: 'amitsinghmanhas2121@gmail.com', price: '299', receipt: 'receipt4.jpg', status: 'Pending' },
    { id: 5, date: '07-Apr-2025', name: 'Umesh Goyal', mobile: '8728978118', email: 'ugoyal593@gmail.com', price: '299', receipt: 'receipt5.jpg', status: 'Rejected' }
  ];

  return (
    <div className="p-6 bg-gradient-to-br from-white to-blue-50 min-h-screen">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-gray-800">Activation Requests</h1>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-xl border border-gray-200">
        {/* Controls */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
          <div className="flex items-center space-x-2">
            <select
              value={entriesPerPage}
              onChange={(e) => setEntriesPerPage(Number(e.target.value))}
              className="px-3 py-2 bg-blue-50 text-gray-700 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-400"
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </select>
            <span className="text-gray-600">entries per page</span>
          </div>

          <div className="flex items-center space-x-2">
            <label className="text-gray-600">Search:</label>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="px-4 py-2 bg-blue-50 text-gray-700 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-400"
              placeholder="Search..."
            />
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-700">
            <thead className="bg-blue-100 text-blue-900 uppercase">
              <tr>
                <th className="px-6 py-3">Sl No.</th>
                <th className="px-6 py-3">Date</th>
                <th className="px-6 py-3">Name</th>
                <th className="px-6 py-3">Mobile</th>
                <th className="px-6 py-3">Email</th>
                <th className="px-6 py-3">Price</th>
                <th className="px-6 py-3">Receipt</th>
                <th className="px-6 py-3">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {requests.map((request) => (
                <tr key={request.id} className="hover:bg-blue-50 transition-colors">
                  <td className="px-6 py-4">{request.id}</td>
                  <td className="px-6 py-4">{request.date}</td>
                  <td className="px-6 py-4 font-semibold">{request.name}</td>
                  <td className="px-6 py-4">{request.mobile}</td>
                  <td className="px-6 py-4">{request.email}</td>
                  <td className="px-6 py-4">₹{request.price}</td>
                  <td className="px-6 py-4">
                    <img
                      src={request.receipt}
                      alt="Receipt"
                      className="w-10 h-10 object-cover rounded-md border border-gray-200"
                    />
                  </td>
                  <td className="px-6 py-4">
                    {request.status === 'Pending' ? (
                      <div className="flex space-x-2">
                        <button className="px-3 py-1 bg-green-500 text-white text-xs rounded-md hover:bg-green-600 transition">
                          Verify
                        </button>
                        <button className="px-3 py-1 bg-red-500 text-white text-xs rounded-md hover:bg-red-600 transition">
                          Reject
                        </button>
                      </div>
                    ) : (
                      <span
                        className={`px-3 py-1 rounded-full text-xs font-medium ${
                          request.status === 'Verified'
                            ? 'bg-green-100 text-green-800'
                            : 'bg-red-100 text-red-800'
                        }`}
                      >
                        {request.status}
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="mt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-gray-600">
            Showing 1 to {entriesPerPage} of {requests.length} entries
          </div>
          <div className="flex space-x-2">
            <button className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition">
              Previous
            </button>
            <button className="px-4 py-2 bg-white text-blue-600 border border-blue-500 rounded-lg hover:bg-blue-100 transition">
              1
            </button>
            <button className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivationRequest;
